import { ExpressionNode } from "../../text/lexer/expressions/ExpressionNode";
import { ConstantExpression } from "../expressions/ConstantExpression";
import { ConstantExpressionFactory } from "../expressions/ConstantExpressionFactory";
import { RJExpressionNode } from "../expressions/RJExpressionNode";
import { RJToken } from "../expressions/RJToken";
import { RJParser } from "../RJParser";
import { Operator } from "./Operator";

export class ConstantOperator extends Operator
{
  _factory:ConstantExpressionFactory;

  constructor( parser:RJParser, tokenMatcher:string|RegExp, factory:ConstantExpressionFactory )
  {
    super( parser );
    this.setStartToken( tokenMatcher, null );
    this._factory = factory;
  }

  processStartNode( nodes:RJExpressionNode[], index:number ):boolean
  {
    let constant:ConstantExpression<any> = this._factory.create( this._parser, nodes, index );

    RJExpressionNode.replaceRange( nodes, index, 1, constant );

    return true;
  }
}